import { Header } from 'react-scale/components/pages/zeitgeist/layout/header';
import { Hero } from 'react-scale/components/pages/zeitgeist/sections/hero';
import { Cards } from 'react-scale/components/pages/zeitgeist/sections/cards';
import { Graph } from 'react-scale/components/pages/zeitgeist/sections/graph';
import { Stats } from 'react-scale/components/pages/zeitgeist/sections/stats';
import { Download } from 'react-scale/components/pages/zeitgeist/sections/download';
import { Footer } from 'react-scale/components/pages/zeitgeist/layout/footer';

import { GlobalCanvas, SmoothScrollbar } from '@14islands/r3f-scroll-rig';
import { Environment, PerformanceMonitor, Preload } from '@react-three/drei';
import { useState } from 'react';
import { useAppStore } from 'react-scale/components/pages/zeitgeist/context/use-app-store';
import { useMedia } from 'react-use';

const Index = () => {
  const [perfSucks, setPerfSucks] = useState(false);
  const isDesktopInPx = useMedia('(min-width: 1024px)');

  return (
    <>
      {isDesktopInPx && (
        <GlobalCanvas
          dpr={[1, perfSucks ? 1.5 : 2]}
          camera={{
            position: [0, 0, 10]
          }}
          eventPrefix="client"
          gl={{
            alpha: true,
            antialias: true,
            powerPreference: 'high-performance'
          }}
          onCreated={() => useAppStore.setState({ canvasLoaded: true })}
          scaleMultiplier={0.01}
          style={{
            height: '100vh',
            left: 0,
            position: 'fixed',
            right: 0,
            top: 0,
            zIndex: 0
          }}
        >
          <Environment files="/static/zeitgeist/2023/studio.hdr" blur={2} />
          <Preload all />
          <PerformanceMonitor onDecline={() => setPerfSucks(true)} />
        </GlobalCanvas>
      )}
      <SmoothScrollbar>
        {_bind => (
          <>
            <Header />
            <Hero />
            <Cards />
            <Graph />
            <Stats />
            <Download />
            <Footer />
          </>
        )}
      </SmoothScrollbar>
    </>
  );
};

Index.theme = 'dark';

export default Index;
